/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import { SortParam } from '@piwikpro/json-api';
import {
  metaSitesFetchInitialized,
  metaSitesFetchSucceeded,
  metaSitesFetchFailed,
  configureMetaSitesFetch,
} from '../../MetaSites';

const isUnderMetaSitesRoute = new RegExp('/meta-sites(.*)');

interface MetaSite {
  type: string
  id: string
  attributes: {
    name: string
    created_at: string
    updated_at: string
  }
}

interface MetaSitesListState {
  isLoading: boolean
  failed: boolean
  metaSites: MetaSite[]
  total: number
  filters: {
    sort: SortParam
  }
}

const initialState: MetaSitesListState = {
  isLoading: true,
  failed: false,
  metaSites: [],
  total: 0,
  filters: {
    sort: {
      by: 'name',
      direction: '',
    },
  },
};

const reducer = handleActions<MetaSitesListState, any>({
  [metaSitesFetchInitialized.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: true,
    metaSites: payload.resetList ? initialState.metaSites : [...state.metaSites],
    total: payload.resetList ? initialState.total : state.total,
  }),
  [metaSitesFetchSucceeded.toString()]: (state, { payload }) => {
    const metaSites = [
      ...state.metaSites,
      ...payload.data,
    ];

    return {
      ...state,
      metaSites: Array.from(new Set(metaSites.map(metaSite => metaSite.id)))
        .map(id => metaSites.find(metaSite => metaSite.id === id)),
      total: state.total > 0 ? state.total : payload.meta.total,
      isLoading: false,
      failed: false,
    };
  },
  [metaSitesFetchFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
    total: 0,
  }),
  [configureMetaSitesFetch.toString()]: (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
    },
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!isUnderMetaSitesRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
